import React from 'react'
import { ScaleLinear } from 'd3-scale'
import { nF, formatSwissDate } from 'components/Charts_Assets'

import './styles.scss'
export const Value = ({
  value,
  x,
  y,
  circle = false,
  offset = 0,
  textAnchor = 'middle',
  line = false,
  unit,
  date,
  prefix
}: {
  value: number
  x: number
  y: ScaleLinear<number, number>
  circle?: boolean
  offset?: number
  textAnchor?: 'middle' | 'start' | 'end'
  line: boolean
  date: string
  unit?: string
  prefix?: string
}) => {
  let lastVal = {
    x: x,
    y: y.range()[0] - y(value),
    text: value
  }
  return (
    <g className='Value'>
      {date && (
        <text
          x={lastVal.x + offset + 6}
          y={lastVal.y - 12}
          textAnchor={textAnchor}
          className='currentdate'
        >
          {formatSwissDate(date, 'short')}
        </text>
      )}
      <text
        x={lastVal.x + offset + 6}
        y={lastVal.y + 4}
        textAnchor={textAnchor}
      >
        {(prefix ? prefix : '') +
          nF(+lastVal.text.toFixed(0)) +
          (unit ? unit : '')}
      </text>
      {line && (
        <line
          x1={lastVal.x + 6}
          x2={lastVal.x + offset + 6}
          y1={lastVal.y}
          y2={lastVal.y}
        />
      )}
      {circle && <circle cx={lastVal.x} cy={lastVal.y} r={3} />}
    </g>
  )
}
